import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { SelectingType } from "./zonesSlice";

export type FleetModeType = "cars" | "drivers" | null;

interface IState {
  mode: FleetModeType;
  selectedDrivers: any[];
  selectedCars: any[];
  carsTypes: any[];
}

const initialState: IState = {
  mode: null,
  selectedDrivers: [],
  selectedCars: [],
  carsTypes: [],
};

export const fleetSlice = createSlice({
  name: "fleet",
  initialState,
  reducers: {
    changeMode: (state, action: PayloadAction<FleetModeType>) => {
      return { ...state, mode: action.payload };
    },
    selectDrivers: (state, action: PayloadAction<any>) => {
      if (state.selectedDrivers.includes(action.payload)) {
        return { ...state, selectedDrivers: state.selectedDrivers.filter((d) => d !== action.payload) };
      }
      return { ...state, selectedDrivers: [...state.selectedDrivers, action.payload] };
    },
    selectCars: (state, action: PayloadAction<any>) => {
      if (state.selectedCars.includes(action.payload)) {
        return { ...state, selectedCars: state.selectedCars.filter((d) => d !== action.payload) };
      }
      return { ...state, selectedCars: [...state.selectedCars, action.payload] };
    },
    selectCarsTypes: (state, action: PayloadAction<any>) => {
      if (state.carsTypes.includes(action.payload)) {
        return { ...state, carsTypes: state.carsTypes.filter((t) => t !== action.payload) };
      }
      return { ...state, carsTypes: [...state.carsTypes, action.payload] };
    },
  },
});

export const { changeMode, selectDrivers, selectCars, selectCarsTypes } = fleetSlice.actions;

export default fleetSlice.reducer;
